import { Injectable } from '@angular/core';
import { IAccountInfo } from '@core/models/admin/account/accountInfo.model';
import { EndpointConstants } from '@core/services/endpoints-configurations/endpoint-constants';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClientRequestService } from '../../../request-services/httpclient.request.services';
import { IUserRoles } from '@core/models/admin/roles/roles.model';
import { HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ManageIdbService } from 'src/app/idb/manage-idb.service';
import { IdbCatalogName } from 'src/app/idb/idb-catalog-name.enum';
import { filter, take } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { getLoginInfo } from 'src/app/store/login/login.selectors';

@Injectable({
  providedIn: 'root',
})
export class RoleRepositoryService {
  private _options = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Ocp-Apim-Subscription-Key': environment.apimSubscriptionKey,
    }),
  };
  private readonly _baseUrl = environment.apiManagmet;
  private readonly _userRolesUrl = `${this._baseUrl}/${EndpointConstants.ApiUserroles}`;
  private _hasUserRoles = new BehaviorSubject<boolean>(false);

  constructor(
    private repo: HttpClientRequestService,
    private _idb: ManageIdbService,
    private _store: Store<Store>,
  ) {}

  getUserRolesAuth(): Observable<IUserRoles[]> {
    return new Observable<IUserRoles[]>((subscriber) => {
      this._idb.select(IdbCatalogName.UserRoles).then((roles: IUserRoles[]) => {
        if (roles?.length) {
          subscriber.next(roles);
          return;
        }
        this._store
          .select(getLoginInfo)
          .pipe(
            filter((info) => Boolean(info)),
            take(1),
          )
          .subscribe((info) => {
            Object.keys(info).forEach((key) => {
              const loginInfo = info[key];
              const request = {
                UserGuid: loginInfo.UserGuid || '',
              } as IAccountInfo;
              this.repo.http
                .post<IUserRoles[]>(this._userRolesUrl, request, this._options)
                .pipe(take(1))
                .subscribe({
                  next: (ur) => {
                    this._idb.saveUserRoles(ur).then();
                    this._hasUserRoles.next(true);
                    subscriber.next(ur);
                  },
                  error: (e) => subscriber.error(e),
                });
            });
          });
      });
    });
  }

  setHasUserRoles = (): void => this._hasUserRoles.next(true);
}
